<template>
  <v-form
    v-if="isShown"
    class="filter white mb-5"
    @submit.prevent="submit"
  >
    <v-container fluid>
      <v-row>
        <v-col cols="2">
          <div class="input-block input-block_white">
            <label class="input-block__label">{{ $t('common.date') }}</label>
            <date-picker
              v-model="localFilter.createdAt"
              :config="{ mode: 'range' }"
              hide-details
            />
          </div>
        </v-col>
        <v-col cols="2">
          <div class="input-block input-block_white">
            <label class="input-block__label">{{ $t('common.name') }}</label>
            <v-text-field
              v-model="localFilter.name"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col cols="2">
          <div class="input-block input-block_white">
            <label class="input-block__label">{{ $t('views.log_list.service') }}</label>
            <v-text-field
              v-model="localFilter.service"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col cols="2">
          <div class="input-block input-block_white">
            <label class="input-block__label">{{ $t('views.log_list.path') }}</label>
            <v-text-field
              v-model="localFilter.path"
              :hint="`{ \&quot;data.prop\&quot;: \&quot;value\&quot; }`"
              solo
              hide-details
            />
          </div>
        </v-col>
        <v-col cols="2">
          <div class="input-block input-block_white">
            <label class="input-block__label">{{ $t('views.log_list.severity') }}</label>
            <v-select
              v-model="localFilter.severity"
              :items="severityLevels"
              clearable
              solo
              hide-details
            />
          </div>
        </v-col>
        <v-col
          cols="2"
          class="filter__apply"
        >
          <v-btn
            type="submit"
            color="primary"
            outlined
            large
            class="filter__apply-button"
          >
            {{ $t('common.apply') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import DatePicker from '@/components/common/DatePicker';

export default {
  name: 'LogsFilter',

  components: {
    DatePicker,
  },

  model: {
    prop: 'isShown',
  },

  props: {
    isShown: {
      type: Boolean,
      default: false,
    },

    filter: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      localFilter: {
        createdAt: null,
        name: '',
        path: '',
        severity: '',
      },

      severityLevels: ['debug', 'info', 'warn', 'error'],
    };
  },

  watch: {
    isShown(value) {
      if (value) {
        this.init();
      }
    },
  },

  methods: {
    init() {
      this.localFilter = { ...this.filter };
    },

    submit() {
      this.$emit('applyFilter', this.localFilter);
    },
  },
};
</script>
